var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[(_vm.newebpayCallBack)?_c('ViewNewpay',{attrs:{"order":_vm.order,"page-type":_vm.pageType}}):(!_vm.isNullOrder)?_c('ViewOrder',{attrs:{"order":_vm.order,"page-type":_vm.pageType}}):_c('ViewNull')],1)}
var staticRenderFns = []

export { render, staticRenderFns }